import { render, staticRenderFns } from "./identityAdmin.vue?vue&type=template&id=34a53867&scoped=true"
import script from "./identityAdmin.vue?vue&type=script&lang=js"
export * from "./identityAdmin.vue?vue&type=script&lang=js"
import style0 from "./identityAdmin.vue?vue&type=style&index=0&id=34a53867&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a53867",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34a53867')) {
      api.createRecord('34a53867', component.options)
    } else {
      api.reload('34a53867', component.options)
    }
    module.hot.accept("./identityAdmin.vue?vue&type=template&id=34a53867&scoped=true", function () {
      api.rerender('34a53867', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/identityAdmin.vue"
export default component.exports